// File Metadata:
// Filename: UsersList.js
// Version: 1.00
// Created: 2022-09-29 09:53:53
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { useGetUsersQuery } from '../api/usersApiSlice'
import User from './User'

const UsersList = () => {
	const {
		data: users,
		isLoading,
		isSuccess,
		isError,
		error
	} = useGetUsersQuery('usersList', {
		pollingInterval: 60000,
		refetchOnFocus: true,
		refetchOnMountOrArgChange: true
	})

	let content

	if (isLoading) content = <p>Loading...</p>

	if (isError) {
		content = <p className='errMsg'>{error?.data?.message}</p>
	}

	if (isSuccess) {
		const { ids } = users
		const { entities } = users
		console.log('UsersList:', users)
		console.log ('UsersList ids:', ids)

		const tableContent = ids?.length && ids.map(_id => <User key={_id} userId={_id} />)

		content = (
			<table className='table table--users'>
				<thead className='table__thead'>
					<tr>
						<th scope='col' className='table__th'>
							Username
						</th>
						<th scope='col' className='table__th'>
							Roles
						</th>
						<th scope='col' className='table__th'>
							Edit
						</th>
					</tr>
				</thead>
				<tbody>{tableContent}</tbody>
			</table>
		)
	}

	return content
}

export default UsersList
